import { render } from "./index-yacht.vue?vue&type=template&id=66c48cb7"
import script from "./index-yacht.vue?vue&type=script&lang=js"
export * from "./index-yacht.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__